import { useTranslation } from "react-i18next";
import Button from "../../components/buttons/button";
import { useState } from "react";
import Popup from "../../components/popups/popup";
import Paginate from "../../components/pagination/paginate";
import SearchSelect from "../../components/select/searchSelect";
import { useOptions } from "../../components/hooks/useOptionsHook";
import { AiOutlinePlusCircle } from "react-icons/ai";
import SearchEvent from "./searchActivity";
import EventsTable from "./activitiesTable";
import ManualRegistration from "./manualRegistration";
import MessagePopup from "../../components/popups/messagePopup";
import DeleteActivity from "./deleteActivity";
import SendNotification from "./sendNotification";
import { useNavigate } from "react-router-dom";

const Activities = () => {
  const { t } = useTranslation();
  const [openDelete, setOpenDelete] = useState(false);
  const [openRegistration, setOpenRegistration] = useState(false);
  const [openSend, setOpenSend] = useState(false);
  const data = { last_page: 10 };
  const { paginationOptions } = useOptions();
  const navigate = useNavigate();
  return (
    <main>
      <div className="flex flex-wrap items-center justify-between md:flex-nowrap">
        <div className="flex items-center gap-2 my-4">
          <p className="font-bold capitalize">{t("eventsManagement")}</p>
        </div>
        <Button
          onClick={() => navigate("/activities/add")}
          className={"bg-primary text-black"}
          type={"button"}
        >
          <AiOutlinePlusCircle />
          {t("addEvent")}
        </Button>
      </div>
      <article className="mainLinear grid p-4 rounded-[20px] mt-8">
        <SearchEvent t={t} />
        <EventsTable
          t={t}
          setOpenRegistration={setOpenRegistration}
          setOpenDelete={setOpenDelete}
          setOpenSend={setOpenSend}
        />
      </article>
      <div className="flex items-center gap-2">
        <Paginate data={data} />
        <div>
          <SearchSelect
            options={paginationOptions}
            onChange={(e) => {
              alert("now paginating " + e.value);
            }}
            name={"paginate"}
            placeholder={t("show 10")}
          />
        </div>
      </div>
      <Popup
        open={openRegistration}
        setOpen={setOpenRegistration}
        header={t("manualMemberRegistration")}
      >
        <ManualRegistration t={t} />
      </Popup>
      <Popup open={openSend} setOpen={setOpenSend} header={t("sendNotification2")}>
        <SendNotification t={t} setOpen={setOpenSend} />
      </Popup>
      <MessagePopup open={openDelete} setOpen={setOpenDelete}>
        <DeleteActivity t={t} setOpen={setOpenDelete} />
      </MessagePopup>
    </main>
  );
};

export default Activities;
